import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Orders from '@/utils/orders';
import { sendWebSocketObj, depthSubcribeHandler, dealsSubscribeHandler } from '@/utils/websocket';
import BigNumber from 'bignumber.js';
import moment from 'moment';
import { getAllMarketId, getMonies, init } from '@/utils/market';
import Utils from '@/utils/Utils';
import { Decimal } from 'decimal.js';
import { initDepth, getDepthList, getDepth } from '@/utils/depth';
import settings from '@/utils/settings';
import Confirm from '@/components/common/Confirm.vue';
import MaskView from '@/components/common/MaskView.vue';
import Config from '@/utils/Config';
import { ConstantUtil } from '@/utils/ConstantUtil';
import Balance from '@/utils/balance';
import RUC from '@/utils/Ruc';

// push originP
const deepcopy = require('deepcopy');

BigNumber.config({
    ROUNDING_MODE: BigNumber.ROUND_FLOOR,
});

export default {
    name: 'Trade',
    data() {
        return {
            lang: localStorage.getItem('lang') || Config.defaultLanguage || 'en',
            assets: [],
            initMarketStatus: false,
            marketsData: [],
            isDepthBottomHeight: false,
            middlePriceHeight: 40,
            depthCellHeight: 20,
            asksSliceNumberHeightRemainder: 0,
            filterMarketValue: '',
            focusStatusBuy: false,
            klineShow: true,
            stockName: '',
            moneyName: '',
            moneyNameActive: '',
            asksSliceNumber: 8,
            single: true,
            maxAsk: 0,
            maxBid: 0,
            buySum: 0,
            sellSum: 0,
            Config,
            amountShowPrec: 4,
            priceShowPrec: 8,
            klineUrl: '',
            curOrder: null,
            orderMask: false,
            orderStatus: 'openOrders',
            orderList: [],
            depth: '0.000001',
            userId: null,
            selectedMarketId: null,
            feeSetting: {
                feeType: 'YES',
                options: [{ key: 1, val: 'YES' }, { key: 0, val: 'NO' }],
                isShow: false,
            },
            /**
             * @userInfo
             */
            stockId: '',
            avaliableStock: '',
            avaliableMoney: '',
            selectedMarket: Utils.getQueryObject().symbol,
            availableBtt: 0,
            /**
             * @MarketInfo
             */
            hasChange: '',
            pricePrec: 0,
            depthList: [],
            amountPrec: 0,
            today: {
                market: '',
                open: '',
                last: '',
                high: '',
                low: '',
                volume: '',
                deal: '',
                cny: '',
                usd: '',
            },
            marketTrades: [],
            asks: [],
            bids: [],
            /**
             * @TrandeInit
             */
            tradeBuy: {
                buy: false,
                sell: false,
            },
            tradeSell: {
                buy: false,
                sell: false,
            },
            /**
             * @ablistShow
             * @all => both show
             * @ask => ask show
             * @bids => bids show
             */
            ablistShow: 'all',
            /**
             * @MarketSelect
             */
            klineHeight: 0,
            klineWidth: 0,
            supportMarket: [],
            leftDistance: 0,
            selectModule: false,
            supportMarketMap: {},
            selectMarketModule: [],
            lastPrice1: 0,
            lastPrice2: 0,
            /**
             * @Trade
             */
            confirmViewType: '',
            selectedTab: 'limitOrder',
            buyPriceValue: '',
            buyAmountValue: '',
            sellPriceValue: '',
            sellAmountValue: '',
            buyPriceCNY: 0,
            buyPriceUSD: 0,
            sellPriceCNY: 0,
            sellPriceUSD: 0,
            useBttAsFee: 0,
            maskView: false,
            confirmView: false,
            moneyId: '',
            buyPercent: 0,
            sellPercent: 0,
            USDPrice: 0,
            CNYPrice: 0,
            currPrice: 0,
            /**
             * @Chart
             */
            dataResolution: '1',
            orderLimit: 5,
            orderCurPage: 1,
        };
    },
    components: {
        VuePerfectScrollbar,
        Confirm,
        MaskView,
    },

    mounted() {
        const self = this;
        const TopbarHeight = 64; // Depth top bar height
        const DepthCellHeight = 20; // Depth cell height
        const MiddlePriceHeight = 40; // Middle price height
        const orderHeight = 19;
        const orderTitleHeight = 29;
        const asksSliceNumberHeight = (this.$refs.listAsks.$el.offsetHeight - TopbarHeight - MiddlePriceHeight);
        this.isDepthBottomHeight = true;
        this.asksSliceNumber = parseInt(asksSliceNumberHeight / 2 / DepthCellHeight);
        const itemSize = (this.asksSliceNumber * 2) + 2;
        const asksSliceNumberHeightRemainder = ((asksSliceNumberHeight + MiddlePriceHeight) - (DepthCellHeight * itemSize)) / itemSize;
        this.depthCellHeight = DepthCellHeight + asksSliceNumberHeightRemainder;
        this.middlePriceHeight = MiddlePriceHeight + (asksSliceNumberHeightRemainder * 2);
        this.orderLimit = parseInt((this.$refs.orders.$el.offsetHeight - orderHeight) / orderTitleHeight);
        this.klineHeight = this.$refs.kline.$el.offsetHeight - 20;
        this.klineWidth = this.$refs.kline.$el.offsetWidth;

        init().then((res) => {
            const markets = res.symbols;
            self.assets = res.currencies;
            localStorage.setItem('assets', JSON.stringify(res.currencies));
            self.marketsData = res.symbols.map((item) => {
                const market = item;
                market.today = { change: '0', price: '0', volume: '0', last: '' };
                return market;
            });
            if (self.$store.state.accountList && self.$store.state.accountList.length > 0) {
                self.userId = self.accountList[self.$store.state.currAccountIndex].userid;
            }
            const supportMarket = [];
            markets.forEach((item) => {
                supportMarket.push(item.quoteName);
                self.supportMarketMap[item.quoteName] = item;
            });
            self.supportMarket = [...new Set(supportMarket)];
            sendWebSocketObj(self, 'today', getAllMarketId(self.marketsData));
            sendWebSocketObj(self, 'cash', [getMonies(self.marketsData).join('/'), 'CNY/USD']);
            self.selectedMarketId = Utils.getQueryObject().id ? Utils.getQueryObject().id : markets[0].symbol;
            self.statusInterval();
        });
    },
    computed: {
        currAccountIndex() {
            return this.$store.state.currAccountIndex;
        },

        cashWebSocketStatus() {
            return this.$store.state.cashWebSocketStatus;
        },
        depthWebSocketStatus() {
            return this.$store.state.depthWebSocketStatus;
        },
        todayWebSocketStatus() {
            return this.$store.state.todayWebSocketStatus;
        },
        dealWebSocketStatus() {
            return this.$store.state.dealWebSocketStatus;
        },
        assetWebScokcetStatus() {
            return this.$store.state.assetWebScokcetStatus;
        },
        cancelAssetWebSocketStatus() {
            return this.$store.state.cancelAssetWebSocketStatus;
        },
        orderWebSocketStatus() {
            return this.$store.state.orderWebSocketStatus;
        },
        assetQueryStatus() {
            return this.$store.state.assetQueryStatus;
        },
        newOrder() {
            return this.$store.state.newOrder;
        },
        balances() {
            return this.$store.state.balances;
        },
        newDeal() {
            return this.$store.state.newDeal;
        },
        newDepth() {
            return this.$store.state.newDepth;
        },
        webSocketIsConnected() {
            return this.$store.state.socket.isConnected;
        },
        priceUSD() {
            return this.$store.state.priceUSD;
        },
        accountList() {
            return this.$store.state.accountList;
        },
        signStatus() {
            return this.$store.state.signStatus;
        },
        priceCNY() {
            return this.$store.state.priceCNY;
        },
        newMarketData() {
            return this.$store.state.newMarketData;
        },
        cancelDealStatus() {
            return this.$store.state.cancelDealStatus;
        },
        cancelDepthStatus() {
            return this.$store.state.cancelDepthStatus;
        },
    },
    watch: {
        cancelAssetWebSocketStatus(n) {
            if (n > 0) {
                sendWebSocketObj(this, 'asset', this.balances.map(item => item.id));
            }
        },
        cancelDealStatus(n) {
            if (n > 0) {
                sendWebSocketObj(this, 'deals', [this.selectedMarketId]);
            }
        },
        cancelDepthStatus(n) {
            if (n > 0) {
                sendWebSocketObj(this, 'depth', [this.selectedMarketId, 100, this.depth]);
            }
        },
        newMarketData(n) {
            const self = this;
            const data = n;
            const key = data[0];
            // copy data
            const value = deepcopy(data[1]);
            // covert today data
            if (value.change != '-1') {
                value.change = parseFloat((value.change - 1) * 100);
            } else {
                value.change = 0;
            }
            self.marketsData = self.marketsData.map((v) => {
                const market = v;
                if (v.symbol == key.toString()) {
                    market.today = value;
                }
                return market;
            });
            if (key.toString() == self.selectedMarketId) {
                self.today = value;
            }
        },
        assetQueryStatus(n) {
            if (this.assetWebScokcetStatus > 0 && n > 0) {
                sendWebSocketObj(this, 'cancelAsset', this.balances.map(item => item.id));
            } else if (n > 0) {
                return sendWebSocketObj(this, 'asset', this.balances.map(item => item.id));
            }
            return null;
        },
        newOrder() {
            this.getOrders(undefined, undefined, 1000);
        },
        balances() {
            this.refreshBalance();
        },
        signStatus(n) {
            if (n > 0) {
                sendWebSocketObj(this, 'assetQuery', []);
                const self = this;
                if (this.orderWebSocketStatus === 0) {
                    window.intervalMarketsData = setInterval(() => {
                        if (this.marketsData.length > 0) {
                            clearInterval(window.intervalMarketsData);
                            sendWebSocketObj(self, 'order', getAllMarketId(self.marketsData));
                            clearInterval(window.intervalMarketsData);
                        }
                    }, 1000);
                }
            }
        },

        newDeal(n) {
            dealsSubscribeHandler(this, n);
        },
        newDepth(n) {
            depthSubcribeHandler(this, n);
            initDepth({ asks: this.asks, bids: this.bids }, '1');
        },
        currAccountIndex(n, o) {
            const self = this;

            if (n !== o) {
                self.userId = self.$store.state.accountList[n].userid;
                sendWebSocketObj(self, 'sign', [self.userId]);
                this.getOrders();
            }

        },
        userId(n, o) {
            if (n != o) {
                sendWebSocketObj(this, 'sign', [this.userId]);
                this.refreshBalance();
                this.getOrders();
            }
            RUC.checkInviter(this.userId, this);

        },
        ablistShow() {
            this.changeDepthAcgtion();
        },
        buyPriceValue() {
            this.calculatePrice('buy');
            this.calculateSum('buy');
        },
        sellPriceValue() {
            this.calculatePrice('sell');
            this.calculateSum('sell');
        },
        buyAmountValue() {
            // if (this.selectedTab !== 'marketOrder') {
            this.calculatePrice('buy');
            // }
            this.calculateSum('buy');
        },
        sellAmountValue() {
            // if (this.selectedTab !== 'marketOrder') {
            this.calculatePrice('sell');
            // }
            this.calculateSum('sell');
        },
        selectedMarketId(n, o) {
            const self = this;
            const markets = self.marketsData;
            let klineUrl = 'https://cdn.bytetrade.io/dev-k/k.html';
            if (process.env.NODE_RUN_ENV === 'TEST') {
                klineUrl = 'https://cdn.bytetrade.io/dev-k/k.html';
            }
            self.klineUrl = `${klineUrl}?v=2&symbol=${n}&v=00001&lang=${self.lang}&host=${settings.HOST}`;
            const market = markets.filter(item => item.symbol == n)[0];
            self.today = market.today;
            self.amountShowPrec = market.precision.amount;
            self.priceShowPrec = market.precision.price;
            self.amountPrec = market.precision.amount;
            self.pricePrec = market.precision.price;
            self.depthList = getDepthList(self.priceShowPrec);
            self.depth = getDepth(market, self.priceShowPrec);
            self.selectedMarket = market.name;
            self.stockName = market.baseName;
            self.moneyName = market.quoteName;
            self.moneyNameActive = market.quoteName;
            self.stockId = market.base;
            self.moneyId = market.quote;
            this.refreshBalance();
            sendWebSocketObj(this, 'deals', [n]);
            // if (o) {
            sendWebSocketObj(this, 'cancelDepth', [o, 100, this.depth]);
           // }
            this.getOrders();
            self.switchTradeType('limitOrder');
        },
    },
    methods: {
        focus(obj) {
            if (obj && obj.focus) {
                obj.focus();
            }
        },
        statusInterval() {
            const self = this;
            setInterval(() => {
                if (self.$store.state.socket.reconnectError || self.$store.state.socket.close || self.$store.state.socket.error || !window.navigator.onLine) {
                    setTimeout(() => {
                        self.getOrders();
                        self.getBalances();
                    }, 2000);
                }
            }, 12000);
        },
        getAsksStart() {
            return this.asks.length - (this.asksSliceNumber * 2) < 0 ? 0 : this.asks.length - (this.asksSliceNumber * 2);
        },
        getBalances() {
            const self = this;
            Balance.getBalance(this.userId, 'balance').then((res) => {
                // self.balances = ;
                self.refreshBalance(res.balances);
            });
        },
        refreshBalance(assets) {
            const self = this;
            const balances = assets || self.balances;
            for (let i = 0; i < balances.length; i += 1) {
                if (balances[i].id == self.moneyId) {
                    self.avaliableMoney = balances[i].available;
                } else if (balances[i].id == self.stockId) {
                    self.avaliableStock = balances[i].available;
                }
            }
            if (balances && balances.length > 0 && (balances[0].symbol === 'BTT' || balances[0].asset === 'BTT')) {
                self.availableBtt = parseFloat(balances[0].available);
            }
        },
        changeHideOhterParis() {
            const self = this;
            setTimeout(() => {
                self.changeOrderStatus(self.orderStatus);
            }, 100);
        },
        selectPrice(order) {
            if (this.selectedTab === 'limitOrder') {
                this.sellPriceValue = order.price;
                this.buyPriceValue = order.price;
            }
        },
        changeDepthAcgtion() {
            const self = this;
            if (self.ablistShow === 'bids') {
                self.maxBid = Math.max(...self.bids.map(item => item.realAmount));
            }
            if (self.ablistShow === 'asks' || self.ablistShow === 'ask') {
                self.maxAsk = Math.max(...self.asks.map(item => item.realAmount));
            }
            if (self.ablistShow === 'all') {
                self.maxAsk = Math.max(...self.asks.slice(self.asks.length - self.asksSliceNumber, self.asks.length).map(item => item.realAmount));
                self.maxBid = Math.max(...self.bids.slice(0, self.asksSliceNumber).map(item => item.realAmount));
            }
        },
        hideMaskView() {
            const self = this;
            self.selectModule = false;
            self.maskView = false;
            self.confirmView = false;
        },
        autoSetPrice(type, key) {
            const self = this;
            if (type === 'tradeBuy') {
                self.tradeBuy = {
                    buy: false,
                    sell: false,
                };
                if (key === 'buy' && self.selectedTab !== 'marketOrder') {
                    self.buyPriceValue = self.bids[0].price;
                }
                if (key === 'sell' && self.selectedTab !== 'marketOrder') {
                    self.buyPriceValue = self.asks[0].price;
                }
                self.calculatePrice('buy');
                self.tradeBuy[key] = true;
            } else if (type === 'tradeSell') {
                self.tradeSell = {
                    buy: false,
                    sell: false,
                };
                if (key === 'buy' && self.selectedTab !== 'marketOrder') {
                    self.sellPriceValue = self.bids[0].price;
                }
                if (key === 'sell' && self.selectedTab !== 'marketOrder') {
                    self.sellPriceValue = self.asks[0].price;
                }
                self.calculatePrice('buy');
                self.tradeSell[key] = true;
            }
            self.tradeSell = self.tradeSell;
            self.tradeBuy = self.tradeBuy;
        },
        setPrice(tradeType, sortType) {
            if (this.selectedTab === 'limitOrder') {
                if (sortType === 'low' && this.asks.length > 0) {
                    if (tradeType === 'buy') {
                        this.buyPriceValue = this.asks[this.asks.length - 1].price;
                    }
                    if (tradeType === 'sell') {
                        this.sellPriceValue = this.asks[this.asks.length - 1].price;
                    }
                }
                if (sortType === 'high' && this.bids.length > 0) {
                    if (tradeType === 'buy') {
                        this.buyPriceValue = this.bids[0].price;
                    }
                    if (tradeType === 'sell') {
                        this.sellPriceValue = this.bids[0].price;
                    }
                }
            }
        },
        calculatePrice(type) {
            const self = this;
            if (type === 'buy') {
                const nowPrice = self.selectedTab === 'marketOrder' ? self.lastPrice1 : self.buyPriceValue;
                const buyPriceValue = new BigNumber(nowPrice);
                const price = buyPriceValue
                    .times(new BigNumber(self.priceUSD[self.moneyName]))
                    .toString();

                self.buyPriceUSD = isNaN(price) ? 0 : price;
            }
            if (type === 'sell') {
                const nowPrice = self.selectedTab === 'marketOrder' ? self.lastPrice1 : self.sellPriceValue;
                const sellPriceValue = new BigNumber(nowPrice);
                const price = sellPriceValue
                    .times(new BigNumber(self.priceUSD[self.moneyName])).toString();
                self.sellPriceUSD = isNaN(price) ? 0 : price;
            }
        },
        calculateSum(type) {
            const self = this;
            if (type === 'buy') {
                const nowPrice = self.selectedTab === 'marketOrder' ? self.lastPrice1 : self.buyPriceValue;

                const buyPriceValue = new BigNumber(nowPrice);
                const buyAmountValue = new BigNumber(self.buyAmountValue).toFixed(self.amountShowPrec);
                const buySum = buyPriceValue.times(buyAmountValue).toFixed(self.priceShowPrec);

                if (self.buyAmountValue != '' && self.buyAmountValue.toString().split('.').length > 1 && self.buyAmountValue.toString().split('.')[1].length > self.amountShowPrec) {
                    self.buyAmountValue = buyAmountValue;
                }
                if (self.selectedTab === 'marketOrder') {
                    self.buySum = buyAmountValue;
                } else {
                    self.buySum = isNaN(buySum) ? 0 : buySum;
                }
                if (self.selectedTab === 'limitOrder' && self.buyPriceValue.toString().split('.').length > 1 && self.buyPriceValue.toString().split('.')[1].length > self.priceShowPrec) {
                    self.buyPriceValue = buyPriceValue.toFixed(self.priceShowPrec);
                }
                // if (self.selectedTab === 'limitOrder' && buyPriceValue != 0) {
                //     self.buyPriceValue = isNaN(buyPriceValue) ? '' : parseFloat(buyPriceValue.toFixed(self.priceShowPrec));
                // }
            }
            if (type === 'sell') {
                const nowPrice = self.selectedTab === 'marketOrder' ? self.lastPrice1 : self.sellPriceValue;

                const sellPriceValue = new BigNumber(nowPrice);
                const sellAmountValue = new BigNumber(self.sellAmountValue).toFixed(self.amountShowPrec);
                const sellSum = sellPriceValue.times(sellAmountValue).toFixed(self.priceShowPrec);
                if (self.sellAmountValue != '' && self.sellAmountValue.toString().split('.').length > 1 && self.sellAmountValue.toString().split('.')[1].length > self.amountShowPrec) {
                    self.sellAmountValue = sellAmountValue;
                }
                if (self.selectedTab === 'limitOrder' && self.sellPriceValue.toString().split('.').length > 1 && self.sellPriceValue.toString().split('.')[1].length > self.priceShowPrec) {
                    self.sellPriceValue = sellPriceValue.toFixed(self.priceShowPrec);
                }
                // if (self.selectedTab === 'limitOrder' && sellPriceValue != 0) {
                //     self.sellPriceValue = isNaN(sellPriceValue) ? '' : parseFloat(sellPriceValue.toFixed(self.priceShowPrec));
                // }
                self.sellSum = isNaN(sellSum) ? 0 : sellSum;
            }
        },
        calculateAmount(type, rate) {
            const self = this;
            let wannaAmount;
            if (type === 'buy') {
                // if (!self.buyPriceValue) {
                //     return;
                // }
                const buyPriceValue = new BigNumber(self.buyPriceValue);
                const available = new BigNumber(self.avaliableMoney);
                if (rate === 0 || buyPriceValue === 0 || available === 0) {
                    return;
                }
                if (self.selectedTab === 'marketOrder') {
                    wannaAmount = available.times(new BigNumber(rate));
                } else {
                    const availableAmount = available.div(buyPriceValue);
                    wannaAmount = availableAmount
                        .times(new BigNumber(rate));
                }
                if (!wannaAmount.toFixed) {
                    return;
                }
                self.buyAmountValue = wannaAmount.toFixed(self.amountShowPrec);
                self.buyPercent = rate;
            } else {
                const tAvailabel = new BigNumber(self.avaliableStock);
                const tWannaAmount = tAvailabel.times(new BigNumber(rate));
                if (!tWannaAmount.toFixed) {
                    return;
                }
                self.sellAmountValue = tWannaAmount.toFixed(self.amountShowPrec);
                self.sellPercent = rate;
            }
        },

        manulChangeMarket(id) {
            if (id === this.selectedMarketId) {
                this.maskView = false;
                return this.selectModule = false;
            }
            const self = this;
            this.$router.push(`/Trade?id=${id}`);

            self.asks = [];
            self.lastPrice = 0;
            self.lastPrice1 = 0;
            self.lastPrice2 = 0;
            self.bids = [];
            self.marketTrades = [];
            self.selectModule = false;
            self.maskView = false;
            self.initMarketStatus = false;
            self.buyPriceValue = '';
            self.sellPriceValue = '';
            self.selectedMarketId = id;
        },
        changeSelectCoin(name) {
            this.moneyNameActive = name;
        },
        showPoppip() {
            const self = this;
            // 过滤列表
            const selectMarketModule = [];
            if (self.marketsData.length === 0) {
                return false;
            }
            self.marketsData.forEach((v) => {
                const curr = v.name.split('/')[1];
                if (curr === self.moneyName) {
                    selectMarketModule.push(v);
                }
            });
            self.maskView = true;
            self.selectMarketModule = selectMarketModule;
            self.selectModule = !self.selectModule;
            return null;
        },
        changePage(type) {
            const self = this;
            let distance = self.leftDistance;
            if (type === 'prev') {
                if (distance > -300) {
                    return false;
                }
                distance += 300;
            } else if (type === 'next') {
                if (distance < -2700) {
                    return false;
                }
                distance -= 300;
            }
            self.leftDistance = distance;
            return true;
        },
        refreshMoney(data) {
            const self = this;
            const assets = Object.keys(data.params[0]);
            assets.forEach((assetId) => {
                for (let i = 0; i < self.balances.length; i += 1) {
                    if (self.balances[i].id == assetId) {
                        self.balances[i].available = data.params[0][assetId][0];
                    }
                }
            });
            self.initUserInfo(self.balances);
        },
        changeDepth(index) {
            const self = this;
            self.depth = self.depthList[index];
            localStorage.setItem(`${self.selectedMarketId}depth`, self.depth);
            self.asks = [];
            self.bids = [];
            sendWebSocketObj(this, 'depth', [self.selectedMarketId, 100, this.depth]);
        },
        getImperialAmount(amountNumber) {
            let amount = parseFloat(amountNumber);
            if (isNaN(amount)) {
                return '';
            }
            if (amount > 1000000) {
                amount /= 1000000;
                amount = BigNumber(amount).toFixed(2);
                // TODO
                amount =
                    amount / 1000 > 1 ? parseFloat(amount / 1000).toFixed(2) : amount;
                amount += 'M';
            } else if (amount < 1000000 && amount > 1000) {
                amount /= 1000;
                amount = BigNumber(amount).toFixed(2);
                amount += 'K';
            } else {
                amount = BigNumber(amount).toFixed(this.amountShowPrec);
            }
            return amount;
        },
        calculateDepth(data) {
            const selfData = data;
            const tmpData = [];
            selfData.forEach((v) => {
                let tmpObj = {};
                const price = v[0];
                const _amount = parseFloat(v[1]);
                let amount = parseFloat(v[1]);
                const realAmount = amount;
                amount = this.getImperialAmount(amount);
                const priceBigNumber = new BigNumber(v[0]);
                const amountBigNumber = new BigNumber(v[1]);
                const total = priceBigNumber
                    .times(amountBigNumber)
                    .toFixed(self.priceShowPrec);
                tmpObj = {
                    price,
                    priceHead: price.substr(0, price.length - 2),
                    priceFoot: price.substr(price.length - 2, price.length),
                    amount,
                    realAmount,
                    total,
                };
                if (_amount !== 0) {
                    tmpData.push(tmpObj);
                }
            });
            return tmpData;
        },
        changeList(ab) {
            const self = this;
            const target = ab;
            self.ablistShow = target;
            this.changeDepthAcgtion();
        },
        /**
         * @OrderPanel
         */
        changeOrderStatus(st, notMask) {
            const self = this;
            const status = st;
            self.orderStatus = status;
            self.orderMask = !notMask;
            self.orderCurPage = 1;
            self.getOrders();
        },
        getOrders(o = 0, m = '', delay = 1) {
            const self = this;
            const type = self.orderStatus;
            const AccountList = self.$store.state.accountList;
            let offset = o;
            if (!AccountList || !AccountList.length) {
                return;
            }
            if (this.orderCurPage === 1) {
                offset = 0;
            } else {
                offset = ((this.orderCurPage - 1) * this.orderLimit) - 1;
            }
            const currAccountIndex = self.$store.state.currAccountIndex;
            const currUser = AccountList[currAccountIndex].userid;
            setTimeout(function () {
                Orders.getOrderList(type, currUser, offset, self.single ? self.selectedMarketId : m, this.orderLimit).then((res) => {
                    self.renderOrders(res.result);
                });
            }, delay);
        },
        renderOrders(data) {
            const self = this;
            const renderData = data;
            self.orderMask = false;
            renderData.forEach((v) => {
                let time;
                let filled;
                const price = new BigNumber(v.price);
                const amount = new BigNumber(v.amount);
                let left = new BigNumber(v.left);
                if (this.orderStatus === 'finishedOrders' && v.type === 'MARKET') {
                    left = 0;
                }
                const already = amount.minus(left);
                const percent = new BigNumber(100);
                const detailShow = false;
                if (!v.left) {
                    filled = 100;
                } else if (v.stock === v.amount) {
                    filled = 100;
                } else {
                    filled = already
                        .div(amount)
                        .times(percent).toFixed(0);
                }

                if (self.orderStatus === 'userDeals') {
                    time = moment(v.time * 1000).format('MM-DD HH:mm');
                    filled = 100;
                } else {
                    time = moment(v.createTime * 1000).format('MM-DD HH:mm');
                }
                if (filled > 99.9) {
                    filled = 100;
                }
                if (this.orderStatus != 'openOrders') {
                    // filled = 100;
                }
                const paTotal = price.times(amount).toFixed();
                Object.assign(v, {
                    time,
                    filled,
                    paTotal,
                    detailShow,
                });
            });
            self.orderList = renderData;
        },
        showOrderDetail(index) {
            const self = this;
            self.orderList[index].detailShow = !self.orderList[index].detailShow;
        },

        switchTradeType(type) {
            const self = this;
            self.selectedTab = type;
            self.buyAmountValue = '';
            self.sellAmountValue = '';
            if (type === 'marketOrder') {
                self.buyPriceValue = '';
                self.sellPriceValue = '';
            } else {
                if (self.asks.length > 0) {
                    self.buyPriceValue = self.asks[self.asks.length - 1].price;
                }
                if (self.bids.length > 0) {
                    self.sellPriceValue = self.bids[0].price;
                }
            }
        },
        showConfirm(type) {
            const self = this;
            let orderType = 0;
            let limitAmout = 0;
            if(type !== 'cancelOrder') {
                if (self.selectedTab === 'marketOrder') {
                    orderType = 2;
                } else {
                    orderType = 1;
                }
    
                if (type === 'buy') {
                    if (self.selectedTab === 'marketOrder') {
                        limitAmout = self.buyAmountValue;
                    } else {
                        limitAmout = self.buyAmountValue * self.buyPriceValue;
                    }
                    if (!self.isPriceAmountValid(self.buyPriceValue, self.buyAmountValue, 2)) {
                        return false;
                    }
                }
                if (type === 'sell') {
                    if (self.selectedTab === 'marketOrder') {
                        limitAmout = self.sellAmountValue;
                    } else {
                        limitAmout = self.sellAmountValue * self.sellPriceValue;
                    }
                    if (!self.isPriceAmountValid(self.sellPriceValue, self.sellAmountValue)) {
                        return;
                    }
                }
                if (parseFloat(limitAmout) == 0) {
                    return self.$Message.error(self.$t('trade_amount_is_too_small'));
                }
                const marketPrice = self.getMarketLastPrice(self.selectedMarketId);
                if (orderType === 2 && marketPrice === 0) {
                    return self.$Message.error(self.$t('trade_market_price_error'));
                }
    
                if (type === 'buy' && parseFloat(self.avaliableMoney) < limitAmout) {
                    self.$Message.error(self.$t('trade_balance_not_enough'));
                }
                let bttAmount = 0;
                if (self.moneyName === 'BTT' && orderType === 2) {
                    bttAmount = 0.0045 + Number(self.buyAmountValue);
                }
                if (self.moneyName === 'BTT' && orderType === 1) {
                    bttAmount = Number(self.buyAmountValue) * Number(self.buyPriceValue) + 0.0045;
                }
                if (parseFloat(self.availableBtt) < ConstantUtil.Number.PackageFee + bttAmount) {
                    return self.$Notice.error({
                        title: 'BttIsNotEnough',
                        desc: (
                            ConstantUtil.Number.PackageFee + bttAmount
                        ).toFixed(6),
                    });
                }
                if (type === 'sell' && parseFloat(self.avaliableStock) < self.sellAmountValue) {
                    return self.$Message.error(self.$t('trade_balance_not_enough'));
                }
            }

            if (!self.$store.getters.currAccount || !self.$store.getters.currAccount.userid) {
                return self.$router.push('/Register');
            }
            if (window.password && window.password[self.$store.getters.currAccount.userid] && (type === 'buy' || type === 'sell')) {
                return self.passCreateOrder({ type, password: window.password[self.$store.getters.currAccount.userid] });
            }
            if (window.password && window.password[self.$store.getters.currAccount.userid] && type === 'cancelOrder') {
                return self.callCancelOrder({ password: window.password[self.$store.getters.currAccount.userid] });
            }

            self.maskView = true;
            self.confirmView = true;
            self.confirmViewType = type;
            return null;
        },
        callCancelOrder(res) {
            const self = this;
            self.maskView = false;
            self.confirmView = false;
            const accountInfo = self.$store.state.accountList[self.currAccountIndex];
            Orders.cancelOrders(accountInfo, accountInfo.userid, self.curOrder, res.password).then(() => {
                self.$Message.success(self.$t('trade_order_submitted'));
            });
        },
        passCreateOrder(res) {
            const self = this;
            self.maskView = false;
            self.confirmView = false;
            if (res.type === 'buy') {
                Orders.buyOrder(res.password, self);
            } else if (res.type === 'sell') {
                Orders.sellOrder(res.password, self);
            }
        },

        isPriceAmountValid(price, amount, side) {
            const self = this;
            let invalidMsg = false;
            try {
                if (this.selectedTab === 'marketOrder') {
                    if (!amount) {
                        invalidMsg = self.$t('trade_amount_can_not_be_empty');
                    } else if (isNaN(amount)) {
                        invalidMsg = 'amount is invaild';
                    }
                } else if (!price || !amount) {
                    invalidMsg = self.$t('trade_amount_can_not_be_empty');
                } else if (isNaN(price) || isNaN(amount)) {
                    invalidMsg = 'input is invaild';
                }
                if (
                    side === 2 &&
                    self.selectedTab === 'limitOrder' &&
                    new Decimal(price)
                        .times(new Decimal(amount))
                        .gt(new Decimal(this.avaliableMoney))
                ) {
                    invalidMsg = self.$t('trade_balance_not_enough');
                }
                if (
                    side === 2 &&
                    self.selectedTab === 'marketOrder' &&
                    parseFloat(self.avaliableMoney) < parseFloat(amount)
                ) {
                    invalidMsg = self.$t('trade_balance_not_enough');
                }
                if (
                    side === 1 &&
                    parseFloat(amount) > parseFloat(self.avaliableStock)
                ) {
                    invalidMsg = self.$t('trade_the_balance_is_not_enough');
                }
            } catch (error) {
                console.log(error);
            }
            if (invalidMsg) {
                self.$Message.error(invalidMsg);
                return false;
            }
            return true;
        },
        getMinAmount(amount, basePrec, minTradeAmount) {
            return BigNumber(BigNumber(amount)
                .times(10 ** basePrec)
                .plus(1)
                .div(minTradeAmount)
                .toFixed(0),
            ).times(minTradeAmount);
        },
        isBttFee(side) {
            const self = this;
            if (self.moneyName === 'BTT' && side === 1) {
                return true;
            }
            return !!self.useBttAsFee;
        },

        getMarketLastPrice(id) {
            const self = this;

            if (self.marketsData && self.marketsData.length > 0) {
                const markets = self.marketsData.filter(
                    item => item.symbol == id,
                );
                if (markets.length > 0) {
                    return markets[0].today.last;
                }
                return 0;
            }
            return 0;
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/trade.js